<template>
  <div class="search-bar">
    <el-date-picker
      v-model="createTime"
      type="daterange"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="timestamp"
      :picker-options="pickerOptions"
      class="zy-date-picker label-input"
      :clearable="false"
      :default-time="['00:00:00', '23:59:59']"
    ></el-date-picker>
    <label-input
      class="label-input"
      label="三方订单号"
      labelWidth="100px"
      placeholder="请输入三方订单号"
      width="330px"
      v-model="orderSn"
      prop="orderSn"
      :input-attr="{ maxlength: 50 }"
      clearable
      valueKey="orderSn"
    />
    <label-input class="label-input" label="流水类型" prop="operateType">
      <el-select v-model="operateType" placeholder="请选择" clearable>
        <el-option
          v-for="item in operateTypeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </label-input>
    <el-button class="el-button--primary is-plain btn" @click="$emit('search')">查询</el-button>
  </div>
</template>

<script>
import labelInput from '@/components/global/form/labelInput';
import Fetch from '@/api';
import moment from 'moment';

export default {
  name: 'searchBar',
  components: {
    labelInput
  },
  props: {
    searchParams: {
      type: Object
    }
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '至今',
            onClick: picker => {
              picker.$emit('pick', []);
            }
          },
          {
            text: '近30天',
            onClick: picker => {
              const end = new Date(moment().endOf('day'));
              const start = new Date(moment().endOf('day'));
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 + 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '近7天',
            onClick: picker => {
              const end = new Date(moment().endOf('day'));
              const start = new Date(moment().endOf('day'));
              console.log(start);
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7 + 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '近3天',
            onClick: picker => {
              const end = new Date(moment().endOf('day'));
              const start = new Date(moment().endOf('day'));
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3 + 1);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {
    orderSn: {
      get() {
        return this.searchParams.orderSn;
      },
      set(val) {
        this.$emit('change', 'orderSn', val);
      }
    },
    operateType: {
      get() {
        return this.searchParams.operateType;
      },
      set(val) {
        this.$emit('change', 'operateType', val);
      }
    },
    createTime: {
      get() {
        return this.searchParams.createTime;
      },
      set(val) {
        this.$emit('change', 'createTime', val);
      }
    },
    operateTypeOptions() {
      return [
        { label: '调账', value: 1 },
        { label: '充值', value: 2 },
        { label: '服务费扣减', value: 3 },
        { label: '服务费返还', value: 4 }
      ];
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.search-bar {
  display: flex;
  margin-bottom: 24px;

  .label-input {
    margin-right: 16px;
  }

  .btn {
    width: 80px;
  }
}
</style>
